import axios from 'axios';
import AxiosError from 'axios-error';
import urlJoin from 'url-join';
import DpitMultiStateAnimBtn from './DpitMultiStateAnimBtn';

export const CLASSES = {
	button: 'dpit-admin-btn'
};


export default class DpitAdminBtnActions {

	constructor(config) {
		if (config.dpDebugEn) console.log('DpitAdminBtnActions');
		this.config = config;
		this.registerActions(['clear_visit_count']);
	}

	registerActions(actionNames) {

		actionNames.forEach((name) => {
			const id = `dpit_action_${name}`;
			const containerEl = document.getElementById(id);
			if (containerEl) {

				const actionButton = new DpitMultiStateAnimBtn(
					(buttonArgs) => this.processAction(buttonArgs?.button, name),
					{
						'default': containerEl.getAttribute('data-title'),
						'success': containerEl.getAttribute('data-msg-success'),
						'error': containerEl.getAttribute('data-msg-failed')
					},
					'default',
					CLASSES.button,
					'button-secondary'

				);
				containerEl.appendChild(actionButton.getButtonElement());
			}
		});
	}
	/**
	 * Insert animation and highlight class to the element
	 * @param {DpitMultiStateAnimBtn} button
	 * @param {string} name
	 */
	processAction = (button, name) => {
		// adjust settings in db

		const dataToPost = { actionName: name };
		button.startAnimation();
		axios.post(
			urlJoin(this.config.siteUrl, '/wp-json/dpintrotours/v1/trigger-action'),
			dataToPost,
			{ headers: { 'X-WP-Nonce': this.config.nonces.wp_rest } }
		)
			.then(() => {
				button.stopAnimation();
				button.setOnlyStateTemporarily('success', 'default');
			})
			.catch(error => {
				console.log(new AxiosError(error));
				button.setOnlyStateTemporarily('failed', 'default');
			});
	};

}